module.exports = __webpack_public_path__ + "img/puff.19727920.svg";